
 

export const TOTAL_SCORE = 100;


// all the decimal values are the percentage (e.g. 0.1 = 10% of the RESPECTIVE_PARENT_SCORE)
export const OVERALL_ANALYSIS_SCORE = 0.1; // 10% of TOTAL_SCORE
export const MAX_SECTIONAL_SCORE = 0.9; // 90% of TOTAL_SCORE



export const STATEMENT_SCORE = {
  grammarMistake: 0.2,
  spellingMistake: 0.2,
  buzzWords: 0.1,
  fillerWords: 0.1,
  endsWithPeriod: 0.1,
  weakVerb: 0.1,
  pastTense: 0.05,
  passiveVoice: 0.05,
  personalPronouns: 0.1
}


export const CORE_SECTTION_SCORES = {
  personalDetails: {
    name: 0.2,
    email: 0.1,
    phone: 0.1,
    linkedin: 0.1,
    statementWeight: 0.5,
    // statement: STATEMENT_SCORE
  },
  education: {
    college: 0.35,
    marks: 0.2,
    degree: 0.2,
    graduationYear: 0.15,
    reverseOrder: 0.1
  },
  project: {
    projectName: 0.2,
    projectLink: 0.2,
    dates: 0.1,
    statementWeight: 0.5,
    // statement: STATEMENT_SCORE,
  },
  experience: {
    dates: 0.1,
    company: 0.05,
    jobTitle: 0.05,
    gapInEmployment: 0.1,
    overlapInEmployment: 0.05,
    isQuantified: 0.1,
    reverseOrder: 0.05,
    statementWeight: 0.5,
    // statement: STATEMENT_SCORE
  },
  skills: {
    present: 1,
  }
}


// the following scores are absolute scores for the overall section and not in percentage
export const OVERALL_ANALYSIS_SCORE_MAP = {
  wordCount: 2,
  bulletPoints: 2,
  repeatedActionVerbs: 2,
  repeatedSentences: 2,
  repeatedPhrases: 1,
  dateStructureConsistency: 1,
}


export const NON_CORE_SECTION_SCORES_MAP = {
  certificates: {
    title: 0.3,
    certificateLink: 0.2,
    statementWeight: 0.5,
    // description: STATEMENT_SCORE
  },
  awards: {
    title: 0.3,
    issuingOrganization: 0.2,
    statementWeight: 0.5,
    // description: STATEMENT_SCORE
  },
  languages: {
    languageName: 0.3,
    proficiencyLevel: 0.2,
    statementWeight: 0.5,
    // description: STATEMENT_SCORE
  },
  customSection: {
    statementWeight: 0.5,
    // description: STATEMENT_SCORE
  }
}
